import { useTranslation } from "react-i18next";
import styles from "./css/MoreButton.module.css";
import { ReactComponent as MarkIcon } from "../../img/iconImgAllBookMark.svg";
import { ReactComponent as UnmarkIcon } from "../../img/iconImgAllBookMarkUnchecked.svg";

interface MarkButtonProps {
  color?: string;
  size?: string;
  isMarked: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
}

export default function MarkButton(props: MarkButtonProps) {
  const { t } = useTranslation();
  function handleOnClickButton(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    // 마우스로 누른 경우 포커스를 풀어, 학습 화면의 Enter 단축키가 이 버튼을 다시 누르지 않게 한다
    if (e.detail > 0) e.currentTarget.blur();
    props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>);
  }

  const Icon = props.isMarked ? MarkIcon : UnmarkIcon;

  return (
    <>
      <button
        type="button"
        className={styles.button}
        aria-label={t("ShowMarkedTermMenuTitle")}
        aria-pressed={props.isMarked}
        onClick={handleOnClickButton}
        style={{
          color: props.isMarked
            ? "var(--icon-green-color)"
            : "var(--icon-secondary-color)",
        }}
      >
        <Icon
          className={styles.icon}
          style={{
            width: props.size !== undefined ? props.size : "24px",
            height: props.size !== undefined ? props.size : "24px",
          }}
        />
      </button>
    </>
  );
}
